<template>
  <nav class="fixed top-0 w-full z-50 bg-white/80 backdrop-blur-sm z-50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center py-4">
        <div class="flex items-center gap-3 justify-between md:justify-start w-full md:w-auto">
          

          <router-link to="/" class="text-2xl font-bold text-gradient" @click="showMobileMenu = false">
            <img :src="entegyLogo" alt="Logo" class="h-12" />
          </router-link>

          <!-- Mobile menu toggle -->
          <button
            type="button"
            class="md:hidden p-2 rounded-full text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500 mr-4"
            aria-label="Open menu"
            @click="showMobileMenu = !showMobileMenu"
          >
            <Bars3Icon class="h-6 w-6" />
          </button>
        </div>
        <div class="hidden md:flex space-x-8">

          <!-- Platform Mega Menu -->
          <div class="relative" @mouseenter="showFeaturesMenu = true" @mouseleave="showFeaturesMenu = false">
            <button
              class="font-headings text-primary-900 text-md font-bold hover:text-primary-500 transition-colors flex items-center py-2">
              Platform
              <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div v-if="showFeaturesMenu" class="absolute -ml-32 left-0 w-[1000px] pt-2 fade-up-in">
              <div
                class="absolute top-0 left-40 w-0 h-0 border-l-[16px] border-r-[16px] border-b-[16px] border-l-transparent border-r-transparent border-b-white">
              </div>
              <div class="flex bg-white rounded-lg shadow-2xl overflow-hidden">
                <!-- Features Section (2/3) -->
                <div class="w-9/12 p-4 border-r border-gray-200">
                  <div class="grid grid-cols-2 gap-4">
                    <router-link v-for="feature in platformFeatures" :key="feature.name" :to="feature.comingSoon ? '#' : feature.link"
                      class="flex items-center gap-4 p-2 rounded-lg hover:bg-gray-50 transition-colors group"
                      :class="{ 'bg-gray-50': feature.link === $route.path }" @click="closeAllMenus">
                      <Icon :icon="feature.icon" variant="gradient" />
                      <div class="flex-1 min-w-0">
                        <div class="text-md font-semibold text-gray-900 group-hover:text-primary-600 font-headings">{{
                          feature.name }} <span v-if="feature.comingSoon" class="text-gray-500 text-xs ml-4">Coming Soon</span>
                        </div>
                        <div class="text-sm text-gray-500 mt-0.5">{{ feature.description }}</div>
                      </div>
                    </router-link>
                  </div>
                </div>

                <!-- Other Platform Features Section (1/3) -->
                <div class="w-3/12 p-6 bg-gray-50 bg-no-repeat">
                  <div class="">
                    <router-link v-for="item in otherPlatformFeatures" :key="item.name" :to="item.link"
                      class="flex items-center p-4 rounded-lg hover:bg-white hover:shadow-sm transition-all border border-transparent hover:border-gray-200 group"
                      @click="closeAllMenus">
                      <component :is="item.icon"
                        class="w-6 h-6 text-secondary-500 mr-3 flex-shrink-0 group-hover:text-secondary-600" />
                      <span class="text-base font-semibold text-gray-900 group-hover:text-secondary-600">{{ item.name
                      }}</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Event Types Mega Menu -->
          <div class="hidden relative" @mouseenter="showEventTypesMenu = true" @mouseleave="showEventTypesMenu = false">
            <button
              class="font-headings text-gray-800 font-bold hover:text-primary-500 transition-colors flex items-center py-2">
              Event Types
              <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div v-if="showEventTypesMenu" class="absolute -ml-32 left-0 w-96 pt-2 fade-up-in">
              <div
                class="absolute top-0 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[16px] border-r-[16px] border-b-[16px] border-l-transparent border-r-transparent border-b-white">
              </div>
              <div class="space-y-4 bg-white rounded-lg shadow-2xl p-2">
                <a v-for="eventType in eventTypes" :key="eventType.name" href="#"
                  class="flex items-center p-4 rounded-lg hover:bg-gray-50 transition-colors group"
                  @click.prevent="closeAllMenus">
                  <div
                    class="shadow-md mt-0.5 mr-4 flex-shrink-0 text-secondary-500 border border-secondary-500 p-1.5 pill-icon transition-all duration-300">
                    <component :is="eventType.icon" class="w-6 h-6" />
                  </div>
                  <div class="flex-1 min-w-0">
                    <div class="text-md font-bold text-gray-900 group-hover:text-secondary-500 font-headings">{{
                      eventType.name }}
                    </div>
                    <div class="text-sm text-gray-500">{{ eventType.description }}</div>
                  </div>
                </a>
              </div>
            </div>
          </div>

          <router-link to="/pricing"
            class="hidden text-gray-800 hover:text-primary-500 transition-colors py-2">Pricing</router-link>

          <!-- Partners Mega Menu -->
          <div class="relative" @mouseenter="showPartnersMenu = true" @mouseleave="showPartnersMenu = false">
            <button
              class="font-headings text-gray-800 font-bold hover:text-primary-500  transition-colors flex items-center py-2">
              Partners
              <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>

            <div v-if="showPartnersMenu" class="absolute -ml-32 left-0 w-96 pt-2 fade-up-in">
              <div
                class="absolute top-0 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[16px] border-r-[16px] border-b-[16px] border-l-transparent border-r-transparent border-b-white">
              </div>
              <div class="space-y-4 bg-white rounded-lg shadow-2xl p-2">
                <router-link v-for="partner in partners" :key="partner.name" :to="partner.link"
                  class="flex items-center p-4 rounded-lg hover:bg-gray-50 transition-colors group"
                  @click="closeAllMenus">
                  <div
                    class="shadow-md mt-0.5 mr-4 flex-shrink-0 text-secondary-500 border border-secondary-500 p-1.5 pill-icon transition-all duration-300">
                    <component :is="partner.icon" class="w-6 h-6" />
                  </div>
                  <div class="flex-1 min-w-0">
                    <div class="text-sm font-bold text-gray-900 group-hover:text-secondary-500">{{ partner.name }}
                    </div>
                    <div class="text-xs text-gray-500">{{ partner.description }}</div>
                  </div>
                </router-link>
              </div>
            </div>


          </div>

          <!-- Solutions Mega Menu -->
          <div class="relative" @mouseenter="showSolutionsMenu = true" @mouseleave="showSolutionsMenu = false">
            <button
              class="font-headings text-gray-800 font-bold hover:text-primary-500 transition-colors flex items-center py-2">
              Solutions
              <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div v-if="showSolutionsMenu" class="absolute left-0 w-[760px] max-w-[calc(100vw-2rem)] pt-2 fade-up-in">
              <div
                class="absolute top-0 left-8 w-0 h-0 border-l-[12px] border-r-[12px] border-b-[12px] border-l-transparent border-r-transparent border-b-white">
              </div>
              <div class="grid grid-cols-3 gap-0 bg-white rounded-lg shadow-2xl p-6 border border-gray-100">
                <div
                  v-for="(section, idx) in solutionsMenu"
                  :key="section.heading"
                  class="px-4"
                  :class="{ 'border-l border-gray-100': idx > 0 }"
                >
                  <div class="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-3">
                    {{ section.heading }}
                  </div>
                  <ul class="space-y-1">
                    <li v-for="link in section.links" :key="link.to">
                      <router-link
                        :to="link.to"
                        class="block py-2 px-2 -mx-2 rounded-md text-sm font-medium text-gray-800 hover:bg-gray-50 hover:text-primary-600 transition-colors"
                        :class="{ 'bg-gray-50 text-primary-700': link.to === $route.path }"
                        @click="closeAllMenus"
                      >
                        {{ link.label }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Resources -->
          <div class="relative" @mouseenter="showResourcesMenu = true" @mouseleave="showResourcesMenu = false">
            <button
              class="font-headings text-gray-800 font-bold hover:text-primary-500 transition-colors flex items-center py-2">
              Resources
              <svg class="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </button>
            <div v-if="showResourcesMenu" class="absolute left-0 w-64 pt-2 fade-up-in">
              <div
                class="absolute top-0 left-6 w-0 h-0 border-l-[12px] border-r-[12px] border-b-[12px] border-l-transparent border-r-transparent border-b-white">
              </div>
              <div class="bg-white rounded-lg shadow-2xl border border-gray-100 py-2">
                <template v-for="item in resourcesMenu" :key="item.label">
                  <a
                    v-if="item.external"
                    :href="item.href"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="block px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-50 hover:text-primary-600 transition-colors"
                    @click="closeAllMenus"
                  >
                    {{ item.label }}
                    <span class="text-xs text-gray-400 ml-1">↗</span>
                  </a>
                  <router-link
                    v-else
                    :to="item.to"
                    class="block px-4 py-3 text-sm font-medium text-gray-800 hover:bg-gray-50 hover:text-primary-600 transition-colors"
                    :class="{ 'bg-gray-50 text-primary-700': item.to === $route.path }"
                    @click="closeAllMenus"
                  >
                    {{ item.label }}
                  </router-link>
                </template>
              </div>
            </div>
          </div>

          <router-link to="/contact"
            class="text-gray-800 font-headings font-bold hover:text-primary-500 transition-colors py-2">Contact</router-link>
        </div>
        <div class="hidden md:flex flex-row gap-4">
          <a href='https://core.entegy.com.au' target='_blank' class="hidden lg:block">
          <div
            class="hover:bg-primary-50 font-headings py-1 px-6 rounded-full font-bold text-sm bg-white text-primary-500 border-2 border-primary-500 flex gap-4 items-center cursor-pointer hover:shadow transition-colors duration-300">
            Login
          </div>
          </a>

          <a href='/signup'>
          <div
            class="transition-colors font-headings duration-300 hover:bg-accent-50 py-1 pl-6 pr-1.5 bg-white text-accent-500 text-sm font-bold hover:shadow rounded-full border-accent-500 border-2 flex gap-4 items-center group cursor-pointer">
            <div>Sign up Now</div>
            <div class="w-6 h-6 p-1 bg-accent-500 rounded-full text-white">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="w-4 h-4 group-hover:rotate-45 transition-transform duration-300">
                <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
              </svg>
            </div>
          </div>
          </a>
        </div>
      </div>
    </div>
  </nav>

  <!-- Mobile menu overlay -->
  <MobileMenu :open="showMobileMenu" @close="showMobileMenu = false" />
</template>

<script setup>
import { ref } from 'vue'
import Icon from './Buttons/Icon.vue'
import MobileMenu from './MobileMenu.vue'
import entegyLogo from '@/images/entegy-logo.svg'
import {
  Bars3Icon,
  MicrophoneIcon,
  BuildingOfficeIcon,
  Squares2X2Icon,
  MagnifyingGlassIcon,
  UserPlusIcon,
  AcademicCapIcon,
  BriefcaseIcon
} from '@heroicons/vue/24/outline'
import { platformFeatures } from '../router/features'
import { solutionsMenu, resourcesMenu } from '../data/navSolutionsAndResources.js'


// Dropdown visibility state
const showFeaturesMenu = ref(false)
const showEventTypesMenu = ref(false)
const showPartnersMenu = ref(false)
const showSolutionsMenu = ref(false)
const showResourcesMenu = ref(false)
const showMobileMenu = ref(false)

function closeAllMenus() {
  showFeaturesMenu.value = false
  showEventTypesMenu.value = false
  showPartnersMenu.value = false
  showSolutionsMenu.value = false
  showResourcesMenu.value = false
}

// Platform features list with icons and descriptions


// Other platform features (bigger, visually distinct)
const otherPlatformFeatures = [
  {
    name: 'Overview',
    icon: Squares2X2Icon,
    link: '/overview'
  },
  /*
  {
    name: 'APIs',
    icon: CodeBracketIcon,
    link: '/apis'
  },
  {
    name: 'Organisation',
    icon: BuildingOffice2Icon,
    link: '/organisation'
  },
  {
    name: 'Security',
    icon: ShieldCheckIcon,
    link: '/security'
  }*/
]

// Event types list
const eventTypes = [
  {
    name: 'Conferences',
    description: 'Engage thousands of delegates effortlessly',
    icon: MicrophoneIcon
  },
  {
    name: 'Exhibitions',
    description: 'Deliver measurable ROI to exhibitors',
    icon: BuildingOfficeIcon
  },
  {
    name: 'Training Events',
    description: 'Track attendance, learning & outcomes',
    icon: AcademicCapIcon
  },
  {
    name: 'Corporate Events',
    description: 'Secure, branded, internal-ready',
    icon: BriefcaseIcon
  }
]

// Partners list
const partners = [
  {
    name: 'Find a Partner',
    description: 'Discover certified partners who can help with your event needs',
    icon: MagnifyingGlassIcon,
    link: '/find-a-partner'
  },
  {
    name: 'Become a Partner',
    description: 'Join our partner program and grow your business with us',
    icon: UserPlusIcon,
    link: '/become-a-partner'
  }
]

</script>

<style>
.pill-icon {
  border-top-left-radius: 25%;
  border-bottom-right-radius: 25%;
}

.group:hover .pill-icon {
  border-top-right-radius: 25%;
  border-bottom-left-radius: 25%;
}

.fade-up-in {
  animation: fade-up-in 0.3s ease-in-out;

}

@keyframes fade-up-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>